export default "__VITE_ASSET__CFQwW5_p__"